module.exports = __webpack_public_path__ + "static/media/step_7.01fc268a.png";